<template>
  <div class="image_slider">
    <div class="container">
      <div class="inner">
        <div class="swiper" :class="section_id">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(tile, index) in parsedImages"
              :data-hash="'slide' + section_id + index"
              :key="index + '_image'"
            >
              <img
                :src="tile.url ? tile.url : null"
                :alt="tile.alt ? tile.alt : 'DCS'"
              />
            </div>
          </div>
          <div
            class="swiper-pagination"
            :class="'swiper-pag-' + section_id"
          ></div>
          <div class="swiper-next-prev">
            <carousel-arrow
              class="swiper-button-prev swiper-button-prv"
              :class="'swiper-button-prev-' + section_id"
              direction="prev"
              theme="dark"
            ></carousel-arrow>
            <carousel-arrow
              class="swiper-button-next swiper-button-nxt"
              :class="'swiper-button-next-' + section_id"
              direction="next"
              theme="dark"
            ></carousel-arrow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarouselArrow from './CarouselArrow.vue';
import Swiper from 'swiper';

export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      swiper: null,
    };
  },

  props: {
    images: {},
    section_id: {},
  },

  computed: {
    parsedImages() {
      if (this.images) {
        return JSON.parse(this.images);
      } else {
        return null;
      }
    },

    parsedCta() {
      if (this.cta) {
        return JSON.parse(this.cta);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.initSliders();
    },

    initSliders() {
      // eslint-disable-next-line no-unused-vars
      var swiper = new Swiper('.' + this.section_id, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        // width: 490,
        // height: 554,
        // hashNavigation: {
        // 	watchState: true,
        // },
        grabCursor: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        // // observer: true,
        // observeParents: true,
        breakpoints: {},
        pagination: {
          el: '.swiper-pag-' + this.section_id,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next-' + this.section_id,
          prevEl: '.swiper-button-prev-' + this.section_id,
        },
      });
    },

    // hasBeenClickedHandler(value) {
    // 	this.hasBeenClicked = value;
    // },
  },

  components: {
    CarouselArrow,
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    this.handleResize();
  },

  mounted() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },

  change() {
    window.dispatchEvent(new Event('resize'));
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';
.image_slider {
  grid-column: span 12;
	
}

.inner {
  grid-column: span 12;
}

.swiper {
  position: relative;
	overflow: hidden;
	background: var(--dark-purple);
}

.swiper-next-prev {
	position: absolute;
	width: 100%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 40;
	z-index: 20;

	/* @media (max-width: $mobile-xl) {
		display: none;
	} */

	.prev {
		opacity: 1;

		@media (max-width: $tablet) {
			top: 50%;
		}
	}

	.next {
		opacity: 1;

		@media (max-width: $tablet) {
			top: 50%;
		}
	}
}

.swiper-slide {
  width: 100% !important;
  aspect-ratio: 16 / 9;

  @media (min-width: $mobile-xl) {
    /* width: 490px !important; */
    /* min-height: 490px; */
  }

  @media (max-width: $mobile-xl) {
    /* margin-right: 0 !important; */
    height: 345px;
    width: unset;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &.nexty {
    &:hover {
      cursor: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNDEiIHZpZXdCb3g9IjAgMCA0MSA0MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAuODk2NSIgY3k9IjIwLjQ1NTQiIHI9IjIwIiBmaWxsPSIjREZFM0U4IiBmaWxsLW9wYWNpdHk9IjAuOCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI3LjMxOCAxNC42NjI3QzI2Ljk0NCAxNC4zMDczIDI2LjMzNzggMTQuMzA3MyAyNS45NjM4IDE0LjY2MjdDMjUuNTg5OSAxNS4wMTgyIDI1LjU4OTkgMTUuNTk0NSAyNS45NjM4IDE1Ljk1TDI5Ljg2NzIgMTkuNjYwOEg5LjczNDgyQzkuMjA2MDIgMTkuNjYwOCA4Ljc3NzM0IDIwLjA2ODMgOC43NzczNCAyMC41NzFDOC43NzczNCAyMS4wNzM4IDkuMjA2MDIgMjEuNDgxMyA5LjczNDgyIDIxLjQ4MTNIMjkuNjI0TDI1Ljk2MzggMjQuOTYwOUMyNS41ODk5IDI1LjMxNjQgMjUuNTg5OSAyNS44OTI3IDI1Ljk2MzggMjYuMjQ4MkMyNi4zMzc4IDI2LjYwMzYgMjYuOTQ0IDI2LjYwMzYgMjcuMzE4IDI2LjI0ODJMMzIuNzM0MiAyMS4wOTkxQzMzLjEwODEgMjAuNzQzNiAzMy4xMDgxIDIwLjE2NzMgMzIuNzM0MiAxOS44MTE4TDI3LjMxOCAxNC42NjI3WiIgZmlsbD0iIzAwM0U3RSIvPgo8L3N2Zz4K'),
        auto;
    }
  }
}

.swiper-pagination {
	position: absolute;
  bottom: 20px !important;
	left: 50% !important;
	transform: translateX(-50%);
	z-index: 15;
  display: flex;
  gap: 10px;
	width: unset !important;

  /* @media (max-width: $mobile-xl) {
    margin: 32px auto;
    position: relative;
    justify-content: center;
  } */

  & > .swiper-pagination-bullet-active {
    background: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ImageSlider.vue